import React, { useCallback, useEffect, useState } from "react";
import "./style/form.css";
import "./style/style.css";

import { Button, Modal } from "react-bootstrap";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import { AiOutlineClose } from "react-icons/ai";

import ProgressBar from "./ProgressBar";
import { StepOnePatientName } from "./StepOnePatientName";
import { StepTwoVendor } from "./StepTwoVendor";
import { StepThreeTests } from "./StepThreeTests";
import { StepFourComplete } from "./StepFourComplete";
import { StepFiveReview } from "./StepFiveReview";

import { getLoggedInPersonName, clinicianIdFromRefreshAuth } from "../../util/authUtil";
import ApiService from "../../ApiService";

const LabOrderRequisition = ({ show, onHide, patientDetails, referenceDetails, referenceLocation }) => {
  const [snackOpen, setSnackOpen] = useState(false);
  const [snackText, setSnackText] = useState("");
  const [snackSeverity, setSnackSeverity] = useState("");
  const handleSnackClose = () => {
    setSnackOpen(false);
  };

  const [isLoading, setIsLoading] = useState(false);

  const [step, setStep] = useState(0);
  const [clinicianName, setClinicianName] = useState("");

  const [testCompendiumList, setTestCompendiumList] = useState([]);
  const [selectedTest, setSelectedTest] = useState([]);
  const [selectedSubTests, setSelectedSubTests] = useState({});
  const [authorId, setAuthorId] = useState(null);
  const [specimenCollectedDate, setSpecimenCollectedDate] = useState(null);
  const [missingGenderAtBirth, setMissingGenderAtBirth] = useState(false);

  useEffect(() => {
    async function assignName() {
      const clinicianName = await getLoggedInPersonName();
      setClinicianName(clinicianName);
      clinicianIdFromRefreshAuth().then(res => setAuthorId(res));
    }
    assignName();
  }, []);
  useEffect(() => {
    if (referenceDetails?.careLocation) {
      ApiService.getTestCompendium("LIFESCAN", referenceDetails?.careLocation?.name)
        .then(response => {
          setTestCompendiumList(response.data);
        })
        .catch(error => {
          console.error(error);
        });
    }
  }, [referenceDetails]);

  const handleSubmit = async () => {
    if (!patientDetails?.genderAtBirth) {
      setMissingGenderAtBirth(true);
      setSnackSeverity("error");
      setSnackText(`Sex At Birth is not present for this patient. Please update it by clicking on the Update Patient Profile button.`);
      setSnackOpen(true);
      return;
    }

    setIsLoading(true);
    try {
      const body = {
        reqEpochSec: Math.floor(Date.now() / 1000),
        collectionEpochSec: Math.floor(Date.now() / 1000),
        patientId: patientDetails?.userId,
        clinicianId: authorId,
        labName: "LIFESCAN",
        refId: referenceDetails?.id,
        refIdType: "BOOKING_ID",
        careLocation: referenceDetails?.careLocation?.name,
        panelTestSpecifications: selectedTest
      };
      const response = await ApiService.postCreateLabRequest(body);
      if (response) {
        onHide(true, false, "Lab Order Created Successfully");
        setStep(0);
      }
    } catch (error) {
      console.error(error);
      setSnackSeverity("error");
      setSnackText("Failed to Create Lab Order");
      setSnackOpen(true);
    } finally {
      setIsLoading(false);
    }
  };

  //TODO : Implement Save as Draft functionality
  const handleSaveDraft = async () => {};

  const openPatientProfile = useCallback(() => {
    window.location.href = `/PatientProfile?patientId=${patientDetails.userId}&idType=sub`;
  }, [patientDetails]);

  return (
    <Modal size="xl" show={show} onHide={onHide}>
      {/* //& Snack Bar */}
      <Snackbar open={snackOpen} autoHideDuration={6000} onClose={handleSnackClose} anchorOrigin={{ vertical: "top", horizontal: "center" }}>
        <Alert onClose={handleSnackClose} severity={snackSeverity}>
          {snackText}
        </Alert>
      </Snackbar>
      <Modal.Header closeButton>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            width: "100%",
            alignItems: "center"
          }}
        >
          <Modal.Title>Lab Order Requisition</Modal.Title>
          <AiOutlineClose
            onClick={() => {
              onHide(false, false);
            }}
            style={{ cursor: "pointer" }}
            size={20}
          />
        </div>
      </Modal.Header>
      <Modal.Body className="modal-body-content">
        <ProgressBar activeStep={step} />
        {step === 0 && <StepOnePatientName patientDetails={patientDetails} />}
        {step === 1 && <StepTwoVendor />}
        {step === 2 && (
          <StepThreeTests
            testCompendiumList={testCompendiumList}
            selectedTest={selectedTest}
            setSelectedTest={setSelectedTest}
            selectedSubTests={selectedSubTests}
            setSelectedSubTests={setSelectedSubTests}
          />
        )}
        {step === 3 && (
          <StepFourComplete
            clinicianName={clinicianName}
            specimenCollectedDate={specimenCollectedDate}
            setSpecimenCollectedDate={setSpecimenCollectedDate}
          />
        )}
        {step === 4 && (
          <StepFiveReview
            patientDetails={patientDetails}
            selectedTest={selectedTest}
            selectedTestsData={selectedTest}
            specimenCollectedDate={specimenCollectedDate}
          />
        )}
      </Modal.Body>
      <Modal.Footer>
        {missingGenderAtBirth && (
          <Button onClick={() => openPatientProfile()} disabled={isLoading} variant="success" style={{ position: "absolute", left: "20px" }}>
            Update Patient Profile
          </Button>
        )}
        {step > 0 && (
          <Button variant="secondary" onClick={() => setStep(step - 1)}>
            Back
          </Button>
        )}
        {step < 4 && (
          <Button variant="primary" onClick={() => setStep(step + 1)}>
            Next
          </Button>
        )}
        {step === 4 && (
          <>
            <Button onClick={() => handleSaveDraft()} disabled={isLoading}>
              {!isLoading ? (
                <>Save as draft</>
              ) : (
                <div
                  className="loading"
                  style={{
                    margin: "5px 20px",
                    height: "20px",
                    width: "20px"
                  }}
                />
              )}
            </Button>
            <Button onClick={() => handleSubmit()} disabled={isLoading}>
              {!isLoading ? (
                <>
                  Submit <i className="fa fa-paper-plane" aria-hidden="true"></i>
                </>
              ) : (
                <div
                  className="loading"
                  style={{
                    margin: "5px 20px",
                    height: "20px",
                    width: "20px"
                  }}
                />
              )}
            </Button>
          </>
        )}
      </Modal.Footer>
    </Modal>
  );
};

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

export default LabOrderRequisition;
